import "js-info-bubble";
import {Loader} from "@googlemaps/js-api-loader";
import helpers from "../modules/helpers";

window.recaptchaOnloadCallback = function () {
    grecaptcha.render("recaptcha_element", {
        sitekey: recaptcha_key,
        size: "checkbox",
        badge: "inline",
        callback: contacts.challange,
    });
};

const contacts = {
    token: "",
    form: $("#contact-form"),
    init: function () {
        if ($("#map-wrap").length) {
            const loader = new Loader({
                apiKey: gmap_api_key,
                version: "weekly",
            });

            loader.load().then((google) => {
                contacts.maps.init($("#map-wrap"));
            });
        }
        if (contacts.form.length) {
            contacts.form.on("submit", function (e) {
                e.preventDefault();
                if (helpers.validate(contacts.form)) {
                    contacts.submit(contacts.token);
                }
            });
        }
    },

    maps: {
        elem: false,
        init: function (elem) {
            this.elem = elem;
            var mapDiv = this.elem[0];

            var map = new google.maps.Map(mapDiv, {
                center: {
                    lat: 56.8766564,
                    lng: 23.4231278,
                },
                zoom: 16,
                disableDefaultUI: false,
                scrollwheel: false,
                fullscreenControl: false,
                streetViewControl: false,
                styles: [
                    {
                        featureType: "administrative",
                        elementType: "geometry.stroke",
                        stylers: [
                            {
                                color: "#cbcbcb",
                            },
                        ],
                    },
                    {
                        featureType: "administrative",
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#919191",
                            },
                        ],
                    },
                    {
                        featureType: "administrative.country",
                        elementType: "geometry.stroke",
                        stylers: [
                            {
                                color: "#bbbbbb",
                            },
                        ],
                    },
                    {
                        featureType: "administrative.locality",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                lightness: "100",
                            },
                        ],
                    },
                    {
                        featureType: "landscape",
                        elementType: "all",
                        stylers: [
                            {
                                color: "#f7f7f7",
                            },
                        ],
                    },
                    {
                        featureType: "poi",
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#eeeeee",
                            },
                        ],
                    },
                    {
                        featureType: "poi",
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#919191",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "all",
                        stylers: [
                            {
                                saturation: -100,
                            },
                            {
                                lightness: 45,
                            },
                            {
                                visibility: "on",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                visibility: "off",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "geometry.stroke",
                        stylers: [
                            {
                                color: "#ffffff",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                visibility: "off",
                            },
                        ],
                    },
                    {
                        featureType: "transit",
                        elementType: "all",
                        stylers: [
                            {
                                visibility: "off",
                            },
                        ],
                    },
                    {
                        featureType: "water",
                        elementType: "all",
                        stylers: [
                            {
                                color: "#ededed",
                            },
                            {
                                visibility: "on",
                            },
                        ],
                    },
                ],
            });

            map.markers = [];

            var markers = $(".contacts__map__nav");
            if (markers.length > 1) {
                var bounds = new google.maps.LatLngBounds();
            }
            var activeBubble = -1;

            markers.each(function (index) {
                var center = new google.maps.LatLng(
                    $(this).data("lat"),
                    $(this).data("lng")
                );
                if (markers.length > 1) {
                    bounds.extend(center);
                }
                var marker_options = {
                    position: center,
                    map: map,
                    animation: google.maps.Animation.DROP,
                };

                if ($(this).data("pin")) {
                    marker_options.icon = $(this).data("pin");
                }
                var marker = new google.maps.Marker(marker_options);
                map.markers.push(marker);

                var infoBubble = new InfoBubble({
                    content: $("[data-item=" + index + "]").html(),
                    arrowSize: 0,
                    arrowPosition: 50,
                    arrowStyle: 0,
                    shadowStyle: 0,
                    padding: 0,
                    borderRadius: 0,
                    borderWidth: 0,
                    backgroundClassName: "google__popup",
                    backgroundColor: "transparent",
                    maxWidth: 290,
                    minWidth: 290,
                    closeSrc: elem.data("close"),
                });

                marker.addListener("click", function () {
                    if (activeBubble != -1) activeBubble.close();
                    activeBubble = infoBubble;
                    infoBubble.open(map, marker);
                });
            });
            if (markers.length > 1) {
                map.fitBounds(bounds);
            } else {
                var marker = markers[0];
                var center = new google.maps.LatLng(
                    $(marker).data("lat"),
                    $(marker).data("lng")
                );
                map.setZoom(15);
                map.setCenter(center);
            }
        },
    },

    challange: function (token) {
        if (token) {
            contacts.token = token;
        }
    },

    submit: function () {
        $.ajax({
            url: ajaxurl,
            type: "POST",
            data: {
                action: "submit_cform",
                contact_token: contacts.token,
                'contact-first-name': $('#first_name').val(),
                'contact-phone': $('#phone').val(),
                'contact-email': $('#email').val(),
                'contact-topic': $('#topic').val(),
                'contact-prod-cat': $('input[name="type_switch"]').is(':checked')
                    ? 'Tehnikas vienība'
                    : 'Cits jautājums',
                'contact-prod': $('#referrer_url').val(),
                'contact-message': $('#message').val(),
                'post-id': $('#post_id').val(),
                'contact-nonce': $('#contact-nonce').val(),
                'contact-honey': $('#contact-honey').val()
            },
            beforeSend: function () {
                $(".form__status").addClass("hidden");
                $("#contact-form button, .contacts__form").addClass("loading");
            },
            success: function (response) {
                // console.log(response);
                $("#contact-form button, .contacts__form").removeClass("loading");
                if (response.success) {
                    $(".errors-wrap").remove();
                    $(".form__status")
                        .removeClass("error")
                        .text(response.data.message)
                        .removeClass("hidden");
                    $("#contact-form")[0].reset();
                    grecaptcha.reset();
                    $("#contact-form").find("input, textarea").blur();
                } else {
                    $(".form__status")
                        .addClass("error")
                        .text(response.data.message)
                        .removeClass("hidden");
                }
            },
        });
    },
};
export default contacts;
